import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoAbastecimentoAguaEnum } from 'graphql/types.generated'

import { tipoAbastecimentoAguaEnumRecord } from './condicoes-moradia-model'

type TipoAbastecimentoAguaSelectFieldProps = CustomSelectFieldProps<TipoAbastecimentoAguaEnum>

export function TipoAbastecimentoAguaSelectField(props: TipoAbastecimentoAguaSelectFieldProps) {
  return <SelectField<TipoAbastecimentoAguaEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(TipoAbastecimentoAguaEnum)
const itemToString = (item: TipoAbastecimentoAguaEnum) => item && tipoAbastecimentoAguaEnumRecord[item]
